// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  subjectKind: __t.string(),
  subjectId: __t.u64(),
  axis: __t.string(),
  subAxis: __t.string(),
  delta: __t.f64(),
  confidence: __t.f64(),
  evidenceRefsJson: __t.string(),
};
